import * as React from "react";

const SvgCube = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill={color} fillRule="nonzero">
      <path d="m12 3 .447-.894a1 1 0 0 0-.894 0L12 3ZM20 7h1a1 1 0 0 0-.553-.894L20 7ZM4 7l-.447-.894A1 1 0 0 0 3 7h1ZM20 17l.447.894A1 1 0 0 0 21 17h-1ZM12 21l-.447.894a1 1 0 0 0 .894 0L12 21ZM4 17H3a1 1 0 0 0 .553.894L4 17Z" />
      <path d="m11.553 3.894 8 4 .894-1.788-8-4z" />
      <path d="m19.553 6.106-8 4 .894 1.788 8-4z" />
      <path d="m12.447 10.106-8-4-.894 1.788 8 4z" />
      <path d="m4.447 7.894 8-4-.894-1.788-8 4zM19.553 16.106l-8 4 .894 1.788 8-4z" />
      <path d="m12.447 20.106-8-4-.894 1.788 8 4z" />
      <path d="M5 17V7H3v10zM21 17V7h-2v10zM11 11v10h2V11z" />
    </g>
  </svg>
);

export default SvgCube;
